export interface FileTitle {
  fileTitle: string;
  fileName: string;
  fileId: string;
  sheetName: string;
}

export interface VaultList {
  Name: string;
  GUID: string;
  Authentication: string;
}

export interface MfilesConfig {
  host: string;
  vaultName: string;
  vaultId: string;
  fileTitle: FileTitle[];
  vaultList: VaultList[];
  viewReportInstalled: boolean;
  isMFilesConnected: boolean;
  vaultToken: string;
  activeSheetName: string;
}

export interface MfilesConfigStateProps {
  data: MfilesConfig;
  isLoader: boolean;
  isError: boolean;
  errorMessage: string;
}
export const mfilesConfigState: MfilesConfigStateProps = {
  data: {
    host: '',
    vaultName: '',
    vaultId: '',
    fileTitle: [],
    vaultList: [],
    viewReportInstalled: false,
    isMFilesConnected: false,
    vaultToken: '',
    activeSheetName: '',
  },
  isLoader: false,
  isError: false,
  errorMessage: '',
};
